import { useContext, useEffect, useState } from "react";
import { DataContext } from "./DataProvider"

const Result = ({ cHeight }) => {
    const [src, setSrc] = useState();
    const { html, css, js } = useContext(DataContext);

    const srcCode = `<html>
    <body>${html}</body>
    <style>${css}</style>
    <script type="text/javascript">${js}</script>
    </html>`;

    useEffect(() => {
        const timeout = setTimeout(() => {
            setSrc(srcCode);
        }, 1000)
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [html, css, js])

    return (
        <iframe
            srcDoc={src}
            title="Output"
            sandbox="allow-scripts"
            width="100%"
            height={cHeight ? `clac(100% + ${cHeight})` : "100%"}
            frameBorder={0}
        />

    );
}

export default Result;